export const faculties = [
  {
    name: "Rohit",
    img: "/images/faculty/Rohit",
    desc: "Ex NDA, Recommended for NDA-136, 21 SSB, Bhopal.",
  },
  {
    name: "Kajal Chaudhary",
    img: "/images/faculty/Kajal",
    desc: "4 times AFSB Recommended, M.Sc Operations Research(Hindu College, DU).",
  },
  {
    name: "Manav Kuri",
    img: "/images/faculty/Manav",
    desc: "AIR 23 (CDS 1 2021), Cleared Airforce XY, Navy SSR, CDS and AFCAT.",
  },
  {
    name: "Nitin Negi",
    img: "/images/faculty/Nitin",
    desc: "AIR 42 (CDS 1 2021), B.Sc IT.",
  },
  {
    name: "Priyanshu",
    img: "/images/faculty/Priyanshu",
    desc: "AIR 6 (NDA 1 2021).",
  },
  {
    name: "Amber Kotnala",
    img: "/images/faculty/Amber",
    desc: "Recommended for ICG - Assistant Commandant(Law), BBA.LL.B, LL.M .",
  },
  {
    name: "Aditya Upadhyay",
    img: "/images/faculty/Aditya",
    desc: "Recommended for 10+2 B.tech Entry for Indian Navy, CDS and AFCAT.",
  },
];
